import gql from 'graphql-tag';

// Tenant isolation: filters by media IDs only — no org filter at query level.
// Callers pass media IDs that were already fetched from org-scoped queries.
// Backend resolvers are responsible for enforcing org-level authorization.
const GET_ADGROUP_CREATIVES_BY_MEDIA = gql`
  query adgroupmedias($media: [ID!], $flag: Boolean = true) {
    adGroupCreativeses(where: { medias_some: { id_in: $media }, flag: true }) {
      id
      medias(where: { flag: $flag }) {
        id
        flag
        name
      }
    }
  }
`;

export default GET_ADGROUP_CREATIVES_BY_MEDIA;
